
import { Vue, Component } from 'vue-property-decorator';
import { getDetail, getBaseInfo } from '../api';
import { Swipe, SwipeItem, Lazyload } from 'vant';
import CustomImagePreview from '../components/ImagePreview.vue';

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload);
@Component({
  components: {
    CustomImagePreview,
  },
})
export default class HomeDetail extends Vue {
  instreamMap: Record<number, string> = {
    1: '小学组（6-12岁青少年）',
    2: '初中组（13-15岁青少年）',
    3: '高中组（16-18岁青少年）',
  };
  obj: any = {};
  baseInfo: any = {};
  isPreviewShow = false;
  previewIndex = 0;

  async activated() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    const res: any = await getDetail(this.$route.query.id);
    this.obj = res.data;
  }
  getImg(imageList: any, index: number) {
    this.previewIndex = index;
    this.isPreviewShow = true;
  }
  getCoverList(cover: any): string[] {
    if (!cover) return [];
    if (Array.isArray(cover)) return cover;
    return String(cover)
      .split('|')
      .filter((item) => !!item);
  }
}
